import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { FormattedMessage } from "react-intl";
import styles from "./ChatbotRoomModal.scss";

export function ChatbotRoomModal({ src, onClose }) {
  // console.log("open chatbotRoom modal", src);
  return (
    <Modal
      title={<FormattedMessage id="chatbot-room-modal.title" defaultMessage="Chatbot Room Modal" />}
      beforeTitle={<CloseButton onClick={onClose} />}
      contentClassName={styles.iframeContainer}
      disableFullscreen={true}
      className={styles.modalContainer}
    >
      <iframe className={styles.iframe} src={src} title="description"></iframe>
    </Modal>
  );
}

ChatbotRoomModal.propTypes = {
  src: PropTypes.string,
  onClose: PropTypes.func
};
